import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import { getUploadProgress } from '@crehana/utils';
import axios from 'axios';
import { BucketsEnum } from "./generated/graphql/types";
import usePreSignatureFile from "./usePreSignatureFile";
export { BucketsEnum };
/**
 * @deprecated This hook is deprecated and will be removed in the next major version.
 * Use the `useEncryptedUploadFile` hook instead from @crehana/react-hooks/file-upload
 */
export var useUploadFile = function useUploadFile(organizationId) {
  var _usePreSignatureFile = usePreSignatureFile(organizationId),
    createPreSignature = _usePreSignatureFile.createPreSignature;
  var _useState = useState(axios.CancelToken.source()),
    _useState2 = _slicedToArray(_useState, 2),
    cancelTokeSource = _useState2[0],
    setCancelTokeSource = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    uploading = _useState4[0],
    setUploading = _useState4[1];
  var uploadFile = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var file, options, onUploadProgress, cancelToken, presignedResponse, formData, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = _ref.file, options = _ref.options, onUploadProgress = _ref.onUploadProgress;
            cancelToken = axios.CancelToken.source();
            setCancelTokeSource(cancelToken);
            setUploading(true);
            _context.prev = 4;
            // biome-ignore lint/style/useBlockStatements: single-line early return
            if (onUploadProgress) onUploadProgress({
              progress: 0,
              uploadSpeed: 0,
              remainingSeconds: 0
            });
            _context.next = 8;
            return createPreSignature(file, options);
          case 8:
            presignedResponse = _context.sent;
            if (!(!presignedResponse.success || !presignedResponse.fileId)) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", {
              success: false,
              error: 'FAILED_TO_GENERATE_PRE_SIGNATURE'
            });
          case 11:
            formData = new FormData();
            presignedResponse.payload.forEach(function (field) {
              if (field.fieldName && field.fieldValue) {
                formData.append(field.fieldName, field.fieldValue);
              }
            });
            formData.append('file', presignedResponse.file);
            _context.next = 16;
            return axios.post(presignedResponse.url, formData, {
              onUploadProgress: createOnUploadProgress(onUploadProgress),
              cancelToken: cancelToken.token,
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          case 16:
            response = _context.sent;
            setUploading(false);
            if (!(response.status !== 204)) {
              _context.next = 20;
              break;
            }
            return _context.abrupt("return", {
              success: false,
              error: 'ERROR_WHILE_UPLOADING_FILE'
            });
          case 20:
            // biome-ignore lint/style/useBlockStatements: single-line early return
            if (onUploadProgress) onUploadProgress({
              progress: 100,
              uploadSpeed: 0,
              remainingSeconds: 0
            });
            return _context.abrupt("return", {
              success: true,
              fileId: String(presignedResponse.fileId),
              url: presignedResponse.url
            });
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](4);
            setUploading(false);
            // biome-ignore lint/style/useBlockStatements: single-line early return
            if (!(_context.t0 instanceof Error)) {
              _context.next = 29;
              break;
            }
            return _context.abrupt("return", {
              success: false,
              error: _context.t0.message
            });
          case 29:
            return _context.abrupt("return", {
              success: false,
              error: 'UNKNOWN_ERROR'
            });
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 24]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [createPreSignature]);
  return {
    uploading: uploading,
    abort: function abort() {
      return cancelTokeSource.cancel('Operation canceled by the user.');
    },
    uploadFile: uploadFile
  };
};
function createOnUploadProgress(callback) {
  var uploadStartDate = new Date();
  var onUploadProgress = callback ? function (progressEvent) {
    var progress = getUploadProgress({
      progressEvent: progressEvent,
      uploadStartDate: uploadStartDate
    });
    callback(progress);
  } : undefined;
  return onUploadProgress;
}